import { FC } from "react";
import { Navigate } from "react-router-dom";
import { atlasRoutes } from "@/app/router/routes";
import { useAtlasAuthContext } from "@/contexts/atlas-auth";

export const RootPage: FC = () => {
  const { authContext } = useAtlasAuthContext();

  if (authContext.isLoading) {
    return null;
  }

  if (authContext.isAuthenticated) {
    return <Navigate to={atlasRoutes.home({}).path} />;
  }

  return <Navigate to={atlasRoutes.logIn({}).path} />;
};
